const search_btn = document.querySelector('nav .search_news');

search_btn.addEventListener('click', event => {

  event.preventDefault();
  event.stopPropagation();

  document.body.classList.toggle('search_state__open');

  if(  document.querySelectorAll('.search-takeover .reading_width').length < 1 ) {
    fetch('/?s=')
      .then(response => {
        return response.text();
      })
      .then(html => {
        let parser = new DOMParser();
      	let doc = parser.parseFromString(html, 'text/html');
        let content = doc.querySelector('main > header .reading_width');
        let container = document.querySelector('.search-takeover');

        container.appendChild(content);
        container.querySelector('#searchform input[type=text]').focus();
      })
      .catch(error => {
        console.error('Error:', error);
      });
  } else {
    document.querySelector('.search-takeover').querySelector('#searchform input[type=text]').focus();
  }

});

document.querySelector('.search-takeover .handle__close').addEventListener('click', event => {

  event.preventDefault();
  event.stopPropagation();

  document.body.classList.toggle('search_state__open');

});
